import GeneralModal from "../../../../components/GeneralModal/GeneralModal";
import { usePermanentlyDeleteMutation } from "../../../../store/builder/inspections.api";
import { toast } from "react-toastify";
import { useTranslation } from "../../../../hooks/useTranslation";
const DeleteEquipmentModal = ({
    equipment, 
    setIsOpen,
    getEquipmentsInitial,
}) => {
    const [
    permanentlyDelete,
    { isLoading: deleteEquipmentIsLoading },
    ] = usePermanentlyDeleteMutation();
    const {t} = useTranslation();
    const handleDelete = () => {
        permanentlyDelete(equipment?.id).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            getEquipmentsInitial();
        });
    }


    return (
    <GeneralModal
          title={t('equipmentTable.modals.delete.title')}
          onClose={() => setIsOpen(false)}
          onSubmit={handleDelete}
          submitTitle={t('equipmentTable.actions.delete')}
          btnType='delete'
          disableSubmit={deleteEquipmentIsLoading}
        >
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            <p className='modal__content-dangerText'>
              {t('equipmentTable.messages.deleteEquipment')}
              <br />
              {t('equipmentTable.messages.deleteEquipmentRelatedData')}
            </p>
          </div>
        </GeneralModal>)
}

export default DeleteEquipmentModal;